export default class MaintenancePreferenceModel {
  constructor(data = {}) {
    this.maintenanceType = data.maintenanceType;
    this.preference = data.preference;
  }
}
